import {config, TYPE_FIMLAB} from "../../../../definitions/TimelineItems";
import {FormattedMessage, injectIntl} from "react-intl";
import {getDepartmentDisplay, isPhoneVisit, isRemoteVisit} from "../../../../utils/TimelineUtils";
import Span from "../../../../components/tag/Span";
import {formatCustom, getTime} from "../../../../utils/TimeUtils";
import React from "react";
import {getLogo} from "../../../../utils/LogoUtils";
import classnames from "classnames";

const TimelineFrameHeaderEventTitle = ({data, linkkipalvelu, past, intl}) => {
    let { title } = {...config[data.type]};

    // This is default if none found
    if (!title) {
        title = {
            message: 'default.timelineitem.title',
        }
    }

    let unitLogo = null;
    const logoFromLinkkipalvelu = linkkipalvelu.Logot && linkkipalvelu.Logot[data.oid];

    if (data.type !== TYPE_FIMLAB) {
        if (
            logoFromLinkkipalvelu &&
            logoFromLinkkipalvelu !== 'fetching' &&
            logoFromLinkkipalvelu !== 'error' &&
            logoFromLinkkipalvelu[0] !== null
        ) {
            const logoAttr = getLogo(logoFromLinkkipalvelu[0].toString());
            if(logoAttr) {
                unitLogo = (
                    <img
                        className="card-logo_image"
                        alt={intl.formatMessage({ id: logoAttr.altTextId })}
                        src={logoAttr.logoSrc}
                    />
                );
            }
        }
    }

    if(isRemoteVisit(data)) {
        title = {
            ...title,
            message: 'remote.timelineitem.title'
        }
    }

    if (isPhoneVisit(data)) {
        title = {
            ...title,
            message: 'phone.timelineitem.title'
        }
    }

    if (data?.config?.type === 'hospitalWard') {
        title = {
            ...title,
            message: 'timeline.frame.hospitalward.title'
        }
    }

    if (data.config && data.config.appointmentSpecificTitle) {
        title = data.config.appointmentSpecificTitle;
    }

    const getDepartmentDescription = () => {
        switch(data.type) {
            case TYPE_FIMLAB:
                return <FormattedMessage id="fimlab.department" />
            default:
                return getDepartmentDisplay(data.department)

            /*
            case TYPE_REFERRAL:
                // TODO: Make a single function to check required message
                // TODO: based on "data.referralState" and "data.referralStateSpecifier"
                // TODO: As seen in TimelineItemWrapper:272
                // TODO: TimelineUtils.js
                return <FormattedMessage
                            id={'test'}
                            values={{
                                department: <u>{getDepartmentDisplay(data.department)}</u>
                            }}/>


            */
        }
    };

    return (
        <>
            <Span sm-len="10" len="10" style={{position:"relative"}}>
                <h1 className="timeline-header-title" style={{margin: "0", marginTop: "10px"}}>
                    { title && title.message && (
                        <FormattedMessage id={title.message} defaultMessage={title.defaultMessage}>
                            {(txt) => <>{txt}</>}
                        </FormattedMessage>
                    )}
                    {title && !(title.message) && (
                        <span>{title}</span>
                    )}
                    {' '}
                    <span className="screen-reader-only">
                        {formatCustom(getTime(data.date), 'LLLL')}
                    </span>
                </h1>
                <div className="card__description">
                    <>
                        <h2 className="timeline-header-title header_description">
                            <span>
                                {getDepartmentDescription()}
                            </span>
                        </h2>
                    </>
                </div>
                {unitLogo &&
                    <div className="timeline-frame-header-logo">
                        <span className={classnames('header__logo', {past: past,})}>
                            {unitLogo}
                        </span>
                    </div>
                }
            </Span>
        </>

    );
};

export default injectIntl(TimelineFrameHeaderEventTitle);